import { useContext } from 'react'
import { toast } from 'react-toastify'

import {
  createOrder as apiCreateOrder,
  updateOrder as apiUpdateOrder,
  closeOrder as apiCloseOrder,
  concludeOrder as apiConcludeOrder,
  reopenOrder as apiReopenOrder,
  sendDocuments as apiSendDocuments
} from '../../../../../services/order'

import { OrderFormatted } from '../../../utils/formatOrder'
import { OrderFormContext } from '../context'
import { useNavigate } from 'react-router-dom'
import { pages } from '../../../../../config/pages'

export function useOrder() {
  const {
    order,
    loading,
    isCertificateOrder,
    setLoading,
    getOrderState,
    updateOrderState
  } = useContext(OrderFormContext)

  const navigate = useNavigate()

  function createOrder(data: Partial<OrderFormatted>) {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => apiCreateOrder(data))
      .then(data => updateOrderState(data))
      .then(() => {
        toast.info('Pedido cadastrado com sucesso')
        navigate(pages.orders.path)
      })
      .finally(() => setLoading(false))
  }

  function updateOrder(data: Partial<OrderFormatted>) {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => getOrderState())
      .then(order => apiUpdateOrder(order.id, data))
      .then(data => updateOrderState(data))
      .then(() => {
        toast.info('O Pedido foi alterado com sucesso')
        navigate(pages.orders.path)
      })
      .finally(() => setLoading(false))
  }

  function closeOrder(onFinally?: () => void) {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => getOrderState())
      .then(order => apiCloseOrder(order.id))
      .then(data => updateOrderState(data))
      .then(() => {
        toast.info('O pedido foi fechado!')
        navigate(pages.orders.path)
      })
      .finally(() => setLoading(false))
      .finally(() => onFinally?.())
  }

  function concludeOrder(statusDate: Date, onFinally?: () => void) {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => getOrderState())
      .then(order => apiConcludeOrder(order.id, statusDate))
      .then(data => updateOrderState(data))
      .then(() => {
        toast.info('Pedido foi concluido')
        navigate(pages.orders.path)
      })
      .finally(() => setLoading(false))
      .finally(() => onFinally?.())
  }

  function reopenOrder(onFinally?: () => void) {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => getOrderState())
      .then(order => apiReopenOrder(order.id))
      .then(data => updateOrderState(data))
      .then(() => {
        toast.info('O pedido foi reaberto')
        navigate(pages.orders.path)
      })
      .finally(() => setLoading(false))
      .finally(() => onFinally?.())
  }

  function sendOrderDocuments(onFinally?: () => void) {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => getOrderState())
      .then(order => apiSendDocuments(order.id))
      .then(() => {
        toast.info('Email foi enviado!')
        navigate(pages.orders.path)
      })
      .finally(() => setLoading(false))
      .finally(() => onFinally?.())
  }

  return {
    order,
    loading,
    isCertificateOrder,
    createOrder,
    updateOrder,
    closeOrder,
    concludeOrder,
    reopenOrder,
    sendOrderDocuments
  }
}
